import styled from 'styled-components';
import { breakpoint } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const RankWrapper = styled.label<{ theme: Theme }>`
  background-color: ${getColor('accentSecondary')};
  ${getBodyStyle('graphikCond', { default: 'large' }, 'semiBold')};
  color: ${getColor('textWhite')};
  cursor: pointer;
  height: 40px;
  width: 40px;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: .25px;

  @media (${breakpoint.lgMin}) {
    width: 48px;
    height: 48px;
    min-width: 48px;
    min-height: 48px;
    font-size: 1.5rem;
  }
`;

export default RankWrapper;
